/**
 * opportunities/editOpportunity/editorBits.js - small constants the record
 * editor and its moved-out pieces share (the family buttons' style, the
 * required fields' labels, blank). Moved out of EditOpportunityModal.jsx.
 */

// "Add PO line" / "Add sub-project" in the project's header
const FAMILY_BTN = {
  background: '#fff',
  color: '#1B5E20',
  border: '1px solid #1B5E20',
  padding: '5px 12px',
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};

// what a required field is called in the "Please fill in" message
const REQUIRED_LABELS = { name: 'Name', customer: 'Customer', quoteDate: 'Quote Date', closeReason: 'Why (Lost / Cancelled / No Quote)' };
const blank = (v) => !String(v == null ? '' : v).trim();

export { FAMILY_BTN, REQUIRED_LABELS, blank };
